/*
 *   Copyright (c) 2021 vlinder
 *   All rights reserved.
 *   This software is proprietary of vlinder and can not be distributed / used for any purpose outside of vlinder without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import _ from 'lodash';
import { createMachine, interpret } from 'xstate';
import { waitFor } from 'xstate/lib/waitFor';

const StateMachine = require('javascript-state-machine');

const is = require('is_js');

export enum AppServiceMachineType {
  DASHBOARD_ANALYTICS_FORMATTER = 'DASHBOARD_ANALYTICS_FORMATTER',
  CREATE_TXN_FORMATTER = 'CREATE_TXN_FORMATTER',
}

export interface AppServiceMachineConfig {
  id: string;
  initial: string;
  predictableActionArguments: true;
  context: any;
  states: any;
  extendContextWith: any;
}

export interface AppServiceSyncMachineConfig {
  init: string;
  transitions: {
    name: string;
    from: string;
    to: string;
  }[];
  data?: {
    message?: any;
  };
  methods: any;
}

export class AppServiceRequestProcessor {
  constructor() {}

  protected async startProcessing({
    machineConfig,
    machineType,
  }: {
    machineConfig: any;
    machineType: AppServiceMachineType;
  }) {
    if (is.not.existy(machineConfig)) {
      throw Error(`machineConfig cannot be empty`);
    }
    if (is.not.existy(machineConfig.id)) {
      throw Error(`id cannot be empty`);
    }
    try {
      const machine = createMachine(machineConfig);
      const interpreter = interpret(machine).onTransition((state) => {
        const stateValue = _.isObject(state.value)
          ? JSON.stringify(state.value)
          : state?.value;

        console.log(`[SM]: id:${machineConfig.id} state: ${stateValue}`);
      });
      const actor = interpreter.start();
      interpreter.send({ type: 'START' });
      const doneState: any = await waitFor(
        actor,
        (state: any) =>
          state.matches('END') ||
          state.matches('ERROR') ||
          state.matches('DOWNSTREAM_EVENTS'),
        {
          timeout: 360000,
        }
      );
      this.checkForError(doneState);
      return doneState?.event?.data;
    } catch (err: any) {
      console.log('error in startProcessing =>', err);
      throw err;
    }
  }

  protected startSyncProcessing({
    machineConfig,
    machineType,
  }: {
    machineConfig: AppServiceSyncMachineConfig;
    machineType: AppServiceMachineType;
  }) {
    console.log('startSyncProcessing');
    if (is.not.existy(machineConfig)) {
      throw Error(`machineConfig cannot be empty`);
    }
    machineConfig.methods.onTriggerEnd = function () {
      return true;
    };
    try {
      const fsm = new StateMachine(machineConfig);
      fsm.observe(
        'onEnterState',
        function (lifecycle: any, arg1: any, arg2: any) {
          console.log(`[SM]: type:${machineType} state: ${lifecycle?.to}`);
        }
      );
      for (const transition of fsm?.allTransitions()) {
        if (fsm?.can(transition)) {
          fsm[transition]();
        }
      }
    } catch (error: any) {
      console.log(
        `error in state machine ${machineType} errorMsg=${error?.message}`
      );
      throw Error(error);
    }
    return true;
  }

  private checkForError(doneState: any) {
    if (doneState?.value === 'ERROR') {
      throw Error(doneState?.event?.data);
    }
  }
}
